import { createViewCatalog } from './viewCatalog.js';

let viewItemsPromise = null;

async function viewItems() {
  if (!viewItemsPromise) {
    viewItemsPromise = fetch('/assets/view-index.json', { cache: 'no-cache' })
      .then((res) => {
        if (!res.ok) throw new Error(`view-index.json ${res.status}`);
        return res.json();
      })
      .catch((error) => {
        viewItemsPromise = null;
        throw error;
      });
  }
  return viewItemsPromise;
}

// The Worker selects sources from descriptions of the complete catalog.
// Search keeps its own lexical and embedding retrieval, independent of View.
export async function candidatesForView() {
  return createViewCatalog(await viewItems());
}

export async function allViewSources() {
  return (await viewItems()).sources || [];
}
